<template>
  <div class="content">
    <van-nav-bar title="开具发票" border fixed left-arrow @click-left="onClickLeft">
      <template #left>
        <van-icon name="arrow-left" size="22" color="#000" />
      </template>
    </van-nav-bar>

    <!-- <van-form @submit="submitInvoice">
      <van-cell-group inset> -->
    <van-field name="invoiceType" label="发票类型">
      <template #input>
        <van-tag
          plain
          size="medium"
          :color="invoiceType === 1 ? h5Config.themeColor : ''"
          :text-color="invoiceType === 1 ? h5Config.themeColor : ''"
          @click="invoiceType = 1"
        >
          个人
        </van-tag>
        &nbsp;&nbsp;
        <van-tag
          plain
          size="medium"
          :color="invoiceType === 2 ? h5Config.themeColor : ''"
          :text-color="invoiceType === 2 ? h5Config.themeColor : ''"
          @click="invoiceType = 2"
        >
          单位
        </van-tag>
      </template>
    </van-field>
    <van-field name="content" label="内容">
      <template #input>
        <van-tag
          plain
          size="medium"
          :color="content === 1 ? h5Config.themeColor : ''"
          :text-color="content === 1 ? h5Config.themeColor : ''"
          @click="content = 1"
        >
          商品明细
        </van-tag>
        &nbsp;&nbsp;
        <van-tag
          plain
          size="medium"
          :color="content === 2 ? h5Config.themeColor : ''"
          :text-color="content === 2 ? h5Config.themeColor : ''"
          @click="content = 2"
        >
          商品类别
        </van-tag>
      </template>
    </van-field>

    <van-field v-model="title" name="title" label="抬头" placeholder="请输入抬头" />
    <van-field
      v-if="invoiceType === 2"
      v-model="taxNo"
      name="taxNo"
      label="税号"
      placeholder="请输入税号"
    />
    <van-field
      v-if="invoiceType === 2"
      v-model="bankName"
      name="bankName"
      label="开户银行"
      placeholder="请输入开户银行"
    />
    <van-field
      v-if="invoiceType === 2"
      v-model="bankAccount"
      name="bankAccount"
      label="银行账户"
      placeholder="请输入银行账户"
    />
    <van-field
      v-if="invoiceType === 2"
      v-model="companyAddress"
      name="companyAddress"
      label="单位地址"
      placeholder="请输入单位地址"
    />
    <van-field
      v-if="invoiceType === 2"
      v-model="companyPhone"
      type="tel"
      name="companyPhone"
      label="单位电话"
      placeholder="请输入单位电话"
    />
    <van-field v-model="emailAddress" name="emailAddress" label="邮箱" placeholder="请输入邮箱" />
    <!-- </van-cell-group> -->
    <!-- <div style="margin: 16px">
        <van-button round block type="primary" native-type="submit"> 提交 </van-button>
      </div> -->
    <!-- </van-form> -->

    <!-- <van-field v-model="totalAmount" name="title" label="金额" style="margin-top: 16px" /> -->

    <div class="bottom">
      <div class="order-amount">
        <div class="order-amount-info">
          <div class="total-amount-text">
            <span class="text-gray-600">开票金额:</span>
            <span class="order-actual-amount">¥{{ orderModel.totalAmount }}</span>
          </div>
        </div>
        <div class="payment-remark">仅支持在线开增值税电子普通发票</div>
      </div>
      <button class="ios-button" @click="submitInvoice"> 提交 </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { onMounted, ref } from 'vue';
  import router from '@/router';
  import { useRoute } from 'vue-router';
  import { getOrder } from '@/service/order';
  import { OrderDetailModel } from '@/model/order';
  import { insertInvoice, getInvoiceList } from '@/service/invoice';
  import h5Config from '@/config/config';
  import { showDialog, showSuccessToast } from 'vant';

  const route = useRoute();
  const orderId = ref(0);
  const orderModel = ref<OrderDetailModel>({});
  const title = ref('');
  const taxNo = ref('');
  const bankName = ref('');
  const bankAccount = ref('');
  const companyAddress = ref('');
  const companyPhone = ref('');
  const invoiceType = ref(1);
  const content = ref(1);
  const emailAddress = ref('');

  onMounted(async () => {
    orderId.value = Number(route.params.id || 0);
    loadOrder();
  });

  const loadOrder = async () => {
    const orderResp = await getOrder({ orderId: orderId.value });
    orderModel.value = orderResp.result || {};

    if (!orderModel.value.orderNo) {
      return;
    }
    const invoiceListResp = await getInvoiceList({
      pageNum: 1,
      pageSize: 1,
      data: {
        orderNo: orderModel.value.orderNo,
        invoiceStatus: 10,
      },
    });
    const invoiceList = invoiceListResp?.result?.list || [];
    if (!invoiceList.length) return;

    const invoiceItem = invoiceList[0];
    const invoiceUrl = invoiceItem.invoiceUrl || '';
    if (invoiceUrl) {
      window.location.replace(invoiceUrl);
    }
  };

  const onClickLeft = () => {
    router.back();
  };

  const submitInvoice = async () => {
    console.log(
      title.value,
      taxNo.value,
      bankName.value,
      bankAccount.value,
      companyAddress.value,
      companyPhone.value,
      invoiceType.value,
      content.value,
      emailAddress.value,
    );

    const res = await insertInvoice({
      shopId: orderModel.value.shopId,
      invoiceType: invoiceType.value,
      title: title.value,
      taxNo: taxNo.value,
      bankName: bankName.value,
      bankAccount: bankAccount.value,
      companyAddress: companyAddress.value,
      companyPhone: companyPhone.value,
      content: content.value === 1 ? '商品明细' : '商品类别',
      orderCount: 1,
      orderNos: [orderModel.value.orderNo],
      invoiceAmount: orderModel.value.totalAmount,
      receiveType: 1,
      emailAddress: emailAddress.value,
    });
    if (res.code === 200) {
      showSuccessToast({ message: '提交成功' });
      loadOrder();
    } else {
      showDialog({ message: res.msg || '开票失败' });
    }
  };
</script>

<style scoped lang="less">
  .content {
    margin-top: 60px;
  }

  .bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 28px;
    z-index: 99;
    background-color: #fff;
    padding: 12px 16px;
    border: none;
    border-top: 1px solid #e5e7eb;

    .order-amount {
      flex: 1;
      text-align: left;

      .order-amount-info {
        display: flex;
        font-size: 14px;
        line-height: 20px;
        color: #4b5563;
        margin-bottom: 4px;

        .total-amount-text {
          margin-right: 10px;
        }
      }

      .order-actual-amount {
        color: #ef4444;
        font-size: 20px;
        font-weight: 700;
        line-height: 28px;
        margin-left: 4px;
      }

      .payment-remark {
        font-size: 12px;
        line-height: 16px;
        color: #6b7280;
      }
    }

    .ios-button {
      background-color: v-bind('h5Config.themeColor');
      color: white;
      border-radius: 12px;
      padding: 12px 20px;
      font-weight: 600;
      width: auto;
      display: inline-block;
      border: none;
      font-size: 16px;
    }
  }
</style>
